import React from "react";
import { ButtonPrimary } from "../../../StyledComponent";
import { SolicitacaoMsgWrapper, MessageWrapper } from "./styles";

import { ReactComponent as IconeEmail } from "../../../../assets/novosicones/Solicitacoes/mark_email_unread.svg";
import scrollToRefElement from "../../../../Utils/scroll";
import useWindowDimension from "../../../../hooks/WindowDimension";

const MsgSolicitacao = ({
  tema,
  respostaRef,
  solicitacaoRespondida,
  statusSolicitacao,
  isSindico,
}) => {
  const verResposta = () => scrollToRefElement(respostaRef);

  const dimensions = useWindowDimension();
  const isShowMessageSendEmail48hours =
    !solicitacaoRespondida &&
    (statusSolicitacao === "Em aberto" ||
      statusSolicitacao === "Em atendimento");

  const isShowSomeMessage =
    solicitacaoRespondida || isShowMessageSendEmail48hours;

  return (
    isShowSomeMessage && (
      <SolicitacaoMsgWrapper tema={tema}>
        {solicitacaoRespondida && (
          <>
            <MessageWrapper
              tema={tema}
              solicitacaoRespondida={solicitacaoRespondida}
            >
              <IconeEmail />
              <div>
                <h2>Sua solicitação foi respondida</h2>
                {dimensions.winWidth > 768 ? (
                  <span>Clique no botão ao lado para ver a resposta</span>
                ) : (
                  <span>Clique no botão abaixo para ver a resposta</span>
                )}
              </div>
            </MessageWrapper>
            <ButtonPrimary tema={tema} onClick={verResposta}>
              VER RESPOSTA
            </ButtonPrimary>
          </>
        )}
        {isShowMessageSendEmail48hours && (
          <MessageWrapper tema={tema}>
            <h2>
              A resposta será enviada para o email do{" "}
              {isSindico ? "síndico" : "titular"} e ficará disponível na sua
              solicitação em até 48 horas úteis.
            </h2>
          </MessageWrapper>
        )}
      </SolicitacaoMsgWrapper>
    )
  );
};

export default MsgSolicitacao;
